import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { COMMON_API } from '../../CommonAPI';

const AddTeam = () => {
  const [form, setForm] = useState({
    name: '',
    designation: '',
    image: null, // store File instead of string
    content: '',
    fb_link: '',
    insta_link: '',
    linked_in_link: ''
  });

  const navigate = useNavigate();

  const handleChange = e => {
    const { name, value, files } = e.target;
    if (name === 'image') {
      setForm({ ...form, image: files[0] }); // store actual file
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const token = sessionStorage.getItem('authToken');
      const formData = new FormData();
      for (const key in form) {
        if (form[key]) formData.append(key, form[key]);
      }

      await axios.post(`${COMMON_API}/api/team/add-team`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      toast.success('Team member added!');
      navigate('/team');
    } catch (error) {
      toast.error('Failed to add team member.');
    }
  };

  return (
    <div className="ml-64 p-8 bg-gray-100 min-h-screen">
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow space-y-4">
        <h2 className="text-2xl font-semibold mb-4">Add Team Member</h2>

        <input
          type="text"
          name="name"
          placeholder="NAME"
          value={form.name}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded"
        />
        <input
          type="text"
          name="designation"
          placeholder="DESIGNATION"
          value={form.designation}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded"
        />
        <input
          type="file"
          name="image"
          accept="image/*"
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded"
        />
        <textarea
          name="content"
          placeholder="CONTENT"
          value={form.content}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded"
        />
        <input
          type="text"
          name="fb_link"
          placeholder="FB LINK"
          value={form.fb_link}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded"
        />
        <input
          type="text"
          name="insta_link"
          placeholder="INSTA LINK"
          value={form.insta_link}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded"
        />
        <input
          type="text"
          name="linked_in_link"
          placeholder="LINKEDIN LINK"
          value={form.linked_in_link}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded"
        />

        <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
          Submit
        </button>
      </form>
    </div>
  );
};

export default AddTeam;
